<template>
  <li class="nav-item d-none d-lg-block">
    <span
      class="nav-link"
      rel="tooltip"
      data-placement="bottom"
      @click.prevent="toggle"
      data-original-title="Expand/Collapse"
    >
      <span v-show="is_expand" :title="$t('message.collapse')"
        ><i class="fas fa-compress-arrows-alt"></i
      ></span>
      <span v-show="!is_expand" :title="$t('message.expand')"
        ><i class="fas fa-expand-arrows-alt"></i
      ></span>
    </span>
  </li>
</template>
<script>
export default {
  methods: {
    toggle() {
      this.$store.commit("expand", !this.is_expand);
      this.$root.$emit("screen-resize", this.is_expand);
    },
  },
  computed: {
    is_expand() {
      return this.$store.state.expand;
    },
  },
};
</script>
